import { render, staticRenderFns } from "./SparsProducts.vue?vue&type=template&id=3f86b63f&scoped=true"
import script from "./SparsProducts.vue?vue&type=script&lang=js"
export * from "./SparsProducts.vue?vue&type=script&lang=js"
import style0 from "./SparsProducts.vue?vue&type=style&index=0&id=3f86b63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f86b63f",
  null
  
)

export default component.exports